export function normalizeSymbolIndexRelPath(filePath: string): string {
  return filePath.replace(/\\/g, '/').replace(/^\/+/, '');
}
